import { render, staticRenderFns } from "./iEditTips.vue?vue&type=template&id=04dffd54&lang=pug"
import script from "./iEditTips.vue?vue&type=script&lang=js"
export * from "./iEditTips.vue?vue&type=script&lang=js"
import style0 from "./iEditTips.vue?vue&type=style&index=0&id=04dffd54&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports